import { GetTranslationData } from "../Components/GetTranslationData/GetTranslationData ";

const getTranslationData = () => ({
  pointsEarn: GetTranslationData("UIClient", "points_you_earn"),
  order_cancelled_by_customer_msg: GetTranslationData(
    "UIClient",
    "order_cancelled_by_customer_msg"
  ),
  pointsEarnedPayment: GetTranslationData(
    "UIClient",
    "points_earned_full_card_payment"
  ),
  pts: GetTranslationData("UIClient", "pts"),
  pointsEarnedPurchase: GetTranslationData(
    "UIClient",
    "earn_points_with_purchase"
  ), // Earn Points with this Purchase
  promoCode: GetTranslationData("UIClient", "i_have_promo_code"), // I have promo code
  promoCodePlaceholder: GetTranslationData(
    "UIClient",
    "promo_code_placeholder"
  ), // Enter Promo Code
  apply: GetTranslationData("UIClient", "apply"),
  giftCard: GetTranslationData("UIClient", "gift_card"), // Gift Card
  discount: GetTranslationData("UIClient", "discount"), // Discount
  totalAmount: GetTranslationData("UIClient", "total_amount"), // Total Amount
  selectCard: GetTranslationData("UIClient", "select_card"), // SELECT CARD
  payWithPointsAndCard: GetTranslationData(
    "UIClient",
    "pay_with_points_and_card"
  ), // Pay with Points And Card
  totalAvailablePoints: GetTranslationData(
    "UIClient",
    "total_available_points"
  ), // Total Available Points
  userDetails: GetTranslationData("UIClient", "user_details"), // User Details
  nameLabel: GetTranslationData("UIClient", "name_label"), // Name
  mobileNo: GetTranslationData("UIClient", "mobile_number"), // Mobile No
  email: GetTranslationData("UIClient", "email"), // Email
  termsAndInstructions: GetTranslationData(
    "UIClient",
    "terms_and_instructions"), // T&C and Instructions
  buyNow: GetTranslationData("UIClient", "buy_now"), // Buy now //
  howToRedeem: GetTranslationData("UIClient", "how_to_redeem"), // How to Redeem?
  note: GetTranslationData("UIClient", "note"), // Note
  demoBomText: GetTranslationData("UIClient", "demo_bom_text"), // Demo BOM Text
  redeemableOnline: GetTranslationData("UIClient", "redeemable_online"), // Redeemable Online
  redeemableOffline: GetTranslationData("UIClient", "redeemable_offline"), // Redeemable Offline
  redeemableBoth: GetTranslationData("UIClient", "redeemable_both"), // Redeemable Both
  value: GetTranslationData("UIClient", "value"), // Value
  qty: GetTranslationData("UIClient", "qty"), // Qty

  showMore: GetTranslationData("UIClient", "show_more"), // Show More
  showLess: GetTranslationData("UIClient", "show_less"), // Show Less
  amazon: GetTranslationData("UIClient", "amazon"), // Amazon
  amazonGiftCard: GetTranslationData("UIClient", "amazon_gift_card"), // Amazon Gift Card
  rewardsEarned: GetTranslationData("UIClient", "rewards_earned"), // Rewards Earned
  saving: GetTranslationData("UIClient", "saving"), // Saving
  youPay: GetTranslationData("UIClient", "you_pay"), // You Pay
  upto15PercentDiscount: GetTranslationData(
    "UIClient",
    "upto_15_percent_discount"
  ), // Upto 15% Discount
  featuredGiftCards: GetTranslationData("UIClient", "featured_gift_cards"), // Featured Gift Cards
  howToUseGiftCard: GetTranslationData("UIClient", "how_to_use_gift_card"), // How to use your Gift Card?
  back: GetTranslationData("UIClient", "back"), // Back
  orderDetails: GetTranslationData("UIClient", "order_details"), // Order Details
  checkout: GetTranslationData("UIClient", "checkout"), // Checkout
  starting: GetTranslationData("UIClient", "starting"), // Starting
  continue: GetTranslationData("UIClient", "continue"), // Continue
  yourEGiftCards: GetTranslationData("UIClient", "your_e_gift_cards"), // Your E-Gift Cards
  orderNumber: GetTranslationData("UIClient", "order_number"), // Order Number
  copiedSuccessfully: GetTranslationData("UIClient", "copied_successfully"), // Copied successfully!
  eGiftCardCode: GetTranslationData("UIClient", "e_gift_card_code"), // E gift card code
  gcId: GetTranslationData("UIClient", "gc_id"), // GC ID
  expDate: GetTranslationData("UIClient", "exp_date"), // Exp Date
  visitNow: GetTranslationData("UIClient", "visit_now"), // Visit Now
  knowMore: GetTranslationData("UIClient", "know_more"), // Know More
  instructions: GetTranslationData("UIClient", "instructions"), // Instructions
  customerHelpDesk: GetTranslationData("UIClient", "customer_help_desk"), // Customer Help Desk
  NoRecordsFound: GetTranslationData("UIClient", "no_records_found"), // No records found
  termsAndConditions: GetTranslationData("UIClient", "terms_and_conditions"), // Terms and Conditions
  importantInstructions: GetTranslationData(
    "UIClient",
    "important_instructions"
  ), // Important Instructions

  orderConfirmation: GetTranslationData("UIClient", "order_confirmation"), // Order Confirmation
  orderAmount: GetTranslationData("UIClient", "order_amount"), // Order Amount
  bonusPoints: GetTranslationData("UIClient", "bonus_points"), // Bonus Points
  earned: GetTranslationData("UIClient", "earned"), // earned
  quantity: GetTranslationData("UIClient", "quantity"), // Quantity
  youPaid: GetTranslationData("UIClient", "you_paid"), // You Paid
  code: GetTranslationData("UIClient", "code"), // Code
  getCode: GetTranslationData("UIClient", "get_code"), // Get Code
  totalValue: GetTranslationData("UIClient", "total_value"), // Total Value
  totalPaid: GetTranslationData("UIClient", "total_paid"), // Total Paid

  enterOtpMessage: GetTranslationData("UIClient", "enter_4_digit_otp"), // Enter 4 digit OTP sent to
  resendOtp: GetTranslationData("UIClient", "resend_otp"), // Resend OTP
  submit: GetTranslationData("UIClient", "submit"), // Submit
  paymentFailed: GetTranslationData("UIClient", "payment_failed"), // Payment Failed
  yourPaymentFor: GetTranslationData("UIClient", "your_payment_for"), // Your Payment for
  couldNotBeProcessed: GetTranslationData("UIClient", "could_not_be_processed"), // could not be processed

  contactSupport: GetTranslationData("UIClient", "contact_support"), // Contact Support
  retryPayment: GetTranslationData("UIClient", "retry_payment"), // Retry Payment
  // paymentNotProcessed: GetTranslationData(
  //     "UIClient",
  //     "payment_not_processed"
  // ), // Your Payment for could not be processed
  availableOnline: GetTranslationData("UIClient", "available_online"), // Available Online
  shopByBrands: GetTranslationData("UIClient", "shop_by_brands"), // Shop by Brands
  category: GetTranslationData("UIClient", "category"), // Category
  chooseYourDenomination: GetTranslationData(
    "UIClient",
    "choose_your_denomination"
  ), // Choose your Denomination
  points: GetTranslationData("UIClient", "points"), // Points
  clearFilter: GetTranslationData("UIClient", "clear_filter"), // Clear filter
  filterAndSort: GetTranslationData("UIClient", "filter_and_sort"), // Filter and Sort
  cancel: GetTranslationData("UIClient", "cancel"), // Cancel
  sortBy: GetTranslationData("UIClient", "sort_by"), // Sort by
  alphabet: GetTranslationData("UIClient", "alphabet"), // Alphabet
  clearSort: GetTranslationData("UIClient", "clear_sort"), // Clear Sort
  howCanWe: GetTranslationData("UIClient", "how_can_we"), // How can we
  helpYouToday: GetTranslationData("UIClient", "help_you_today"), //  help you today?
  contactNo: GetTranslationData("UIClient", "contact_no"), // Contact No
  contactMe: GetTranslationData("UIClient", "contact_me"), // Contact Me
  emailAddress: GetTranslationData("UIClient", "email_address"), // Email Address
  selectTheProduct: GetTranslationData("UIClient", "select_the_product"), // Select the product
  appleProduct: GetTranslationData("UIClient", "apple_product"), // Apple Product
  googlePlayStore: GetTranslationData("UIClient", "google_play_store"), // Google Play Store
  howCanWeHelpYou: GetTranslationData("UIClient", "how_can_we_help_you"), // How can we help you
  writeHere: GetTranslationData("UIClient", "write_here"), // Write here....
  attachAFile: GetTranslationData("UIClient", "attach_a_file"), // Attach a File
  reachUsAt: GetTranslationData("UIClient", "reach_us_at"), // Reach us at
  errorInImagePath: GetTranslationData("UIClient", "error_in_image_path"), // Error in image path
  off: GetTranslationData("UIClient", "off_label"), // OFF
  buyAndEarnUpTo: GetTranslationData("UIClient", "buy_and_earn_up_to"), // Buy & Earn up to
  startingFrom: GetTranslationData("UIClient", "starting_from"), // Starting from
  orRedeemFrom: GetTranslationData("UIClient", "or_redeem_from"), // or redeem from
  redeemFrom: GetTranslationData("UIClient", "redeem_from"), // Redeem from
  select: GetTranslationData("UIClient", "select"), // Select
  expired: GetTranslationData("UIClient", "expired"), // Expired

  addToCart: GetTranslationData("UIClient", "add_to_cart"), // Add to Cart

  orderPlaced: GetTranslationData("UIClient", "order_placed"), // Order Placed
  thankYou: GetTranslationData("UIClient", "thank_you"), // THANK YOU

  editUserDetails: GetTranslationData("UIClient", "edit_user_details"), // Edit User Details
  deliverTo: GetTranslationData("UIClient", "deliver_to"), // Deliver to
  yourOrderSummary: GetTranslationData("UIClient", "your_order_summary"), // Your order summary
  subTotal: GetTranslationData("UIClient", "sub_total"), // Sub Total
  redeemYour: GetTranslationData("UIClient", "redeem_your"), // Redeem Your
  height: GetTranslationData("UIClient", "height"), // Height
  centimetre: GetTranslationData("UIClient", "centimetre"), // Centimetre
  amountDue: GetTranslationData("UIClient", "amount_due"), // Amount Due
  paymentMethod: GetTranslationData("UIClient", "payment_method"), // Payment Method
  fullName: GetTranslationData("UIClient", "full_name"), // Full Name

  aboutGiftstacc: GetTranslationData("UIClient", "about_giftstacc"), // About Giftstacc
  termsConditions: GetTranslationData("UIClient", "terms_conditions"), // Terms & Conditions
  privacyPolicy: GetTranslationData("UIClient", "privacy_policy"), // Privacy Policy
  faq: GetTranslationData("UIClient", "faq"), // FAQ
  contactUs: GetTranslationData("UIClient", "contact_us"), // Contact us
  cancellationAndReturn: GetTranslationData(
    "UIClient",
    "cancellation_and_return"
  ), // Cancellation & Return
  aboutUs: GetTranslationData("UIClient", "about_us"), // About Us
  refundPolicy: GetTranslationData("UIClient", "refund_policy"), // Refund Policy
  firstName: GetTranslationData("UIClient", "first_name"), // First Name
  lastName: GetTranslationData("UIClient", "last_name"), // Last Name
  emailId: GetTranslationData("UIClient", "email_id"), // Email id

  myWishlist: GetTranslationData("UIClient", "my_wishlist"), // My Wishlist
  amazonShoppingVoucher: GetTranslationData(
    "UIClient",
    "amazon_shopping_voucher"
  ), // Amazon Shopping Voucher
  eGiftCard: GetTranslationData("UIClient", "e_gift_card"), // E-Gift Card
  price: GetTranslationData("UIClient", "price"), // Price
  moveToCart: GetTranslationData("UIClient", "move_to_cart"), // Move to Cart
  errorName: GetTranslationData("UIClient", "permission_denied"), // Permission Denied
  errorDescription: GetTranslationData("UIClient", "not_able_to_access_url"), // You are not able to access this url
  backToHome: GetTranslationData("UIClient", "back_to_home"), // Back to Home
  more: GetTranslationData("UIClient", "more"), // More
  eGiftCards: GetTranslationData("UIClient", "e_gift_cards"), // e-Gift Cards
  shopByCategory: GetTranslationData("UIClient", "shop_by_category"), // Shop by category
  orders: GetTranslationData("UIClient", "orders"), // Orders
  orderDate: GetTranslationData("UIClient", "order_date"), // Order Date
  amazonPay: GetTranslationData("UIClient", "amazon_pay"), // Amazon Pay
  yourOrders: GetTranslationData("UIClient", "your_orders"), // Your Orders
  exploreGiftCards: GetTranslationData("UIClient", "explore_gift_cards"), // Explore Gift Cards
  myAccount: GetTranslationData("UIClient", "my_account"), // My Account
  myOrders: GetTranslationData("UIClient", "my_orders"), // My Orders
  discountFlat: GetTranslationData("UIClient", "discount_flat"), // Discount Flat
  orderSummary: GetTranslationData("UIClient", "order_summary"), // Order Summary
  total: GetTranslationData("UIClient", "total"), // Total
  pointsUsed: GetTranslationData("UIClient", "points_used"), // Points Used
  phoneSkype: GetTranslationData("UIClient", "phone_skype"), // Phone/Skype
  aboutYourProject: GetTranslationData("UIClient", "about_your_project"), // About Your Project
  hi: GetTranslationData("UIClient", "hi_label"), // Hi
  searchGiftCard: GetTranslationData("UIClient", "search_gift_card"), // Search any Gift card
  earn: GetTranslationData("UIClient", "earn"), // Earn
  footerCopyright: GetTranslationData("UIClient", "footer_copyright"), // 2025 Giftstacc All rights reserved. Powered by Customer Capital
  applicationUrlIsNotRegistered: GetTranslationData(
    "UIClient",
    "application_url_is_not_registerd"
  ),
  internalServerError: GetTranslationData("UIClient", "internal_server_error"),
  permissionToViewThisResource: GetTranslationData(
    "UIClient",
    "permission_to_view_this_resource"
  ),
  continueShopping: GetTranslationData("UIClient", "continue_shopping"),
  goToMyOrder: GetTranslationData("UIClient", "go_to_my_order"),
  canNotAddMoreThan10: GetTranslationData(
    "UIClient",
    "can_not_add_more_than_10"
  ),
  pleaseAddSomeProductsQuantitys: GetTranslationData(
    "UIClient",
    "please_add_some_products_quantitys"
  ),
  instantVouchers: GetTranslationData("UIClient", "instant_vouchers"),
  giftCardPurchaseSuccess: GetTranslationData(
    "UIClient",
    "e_gift_card_purchase_success"
  ),
  keepShoppingEarnMore: GetTranslationData(
    "UIClient",
    "keep_shopping_earn_more"
  ),
  errorInSendingOTP: GetTranslationData("UIClient", "error_in_sending_OTP"),
  backToHomepage: GetTranslationData("UIClient", "back_to_homepage"),
  redeemPointsCheckout: GetTranslationData(
    "UIClient",
    "redeem_points_checkout"
  ),
  pleaseAddTheProduct: GetTranslationData("UIClient", "please_add_the_product"),
  only10ProductsCanBeAllowed: GetTranslationData(
    "UIClient",
    "only_10_products_can_be_allowed"
  ),
  rupee_Symbol: GetTranslationData("UIClient", "rupee_Symbol"),
  products: GetTranslationData("UIClient", "products"),
  showing: GetTranslationData("UIClient", "showing"),
  results: GetTranslationData("UIClient", "results"),
  trendingOnly: GetTranslationData("UIClient", "trendingOnly"),
  toggle: GetTranslationData("UIAdmin", "toggle"),
  detailsSentRegistered: GetTranslationData(
    "UIClient",
    "details_sent_registered"
  ),
  mobileEmail: GetTranslationData("UIClient", "mobile_email"),
  detailsSentRegisteredContact: GetTranslationData(
    "UIClient",
    "details_sent_registered_contact"
  ),
  emailSentSuccessfully: GetTranslationData(
    "UIClient",
    "email_sent_successfully"
  ),
  retrieveCode: GetTranslationData("UIClient", "retrieve_code"),
  resendCode: GetTranslationData("UIClient", "resend_code"),
  earnUpto: GetTranslationData("UIClient", "earn_upto"),
  loginLabel: GetTranslationData("UIAdmin", "login_label"),
  myProfile: GetTranslationData("UIAdmin", "my_Profile"),
  searchForGiftcard: GetTranslationData("UIAdmin", "search_for_giftcard"),
  filters: GetTranslationData("UIAdmin", "filters"),
  order_failed_orderdetails: GetTranslationData(
    "UIClient",
    "order_failed_orderdetails"
  ),
  vendor_order_failed_orderdetails: GetTranslationData(
    "UIClient",
    "vendor_order_failed_orderdetails"
  ),
  offLabel: GetTranslationData("UIClient", "off_label"), // Off
  offLower: GetTranslationData("UIClient", "off_lower"), // off
  routeNotFound: GetTranslationData("UIClient", "route_not_found"), // Route not found
  pageNotFoundMessage: GetTranslationData("UIClient", "page_not_found_message"), // The page you were looking for is not found!
  congratsYouHaveOrdered: GetTranslationData(
    "UIClient",
    "congrates_you_have_ordered"
  ), // Congrats! You’ve ordered
  worth: GetTranslationData("UIClient", "worth_₹"), // worth ₹
  bankOfMaharashtra: GetTranslationData("UIClient", "bank_of_maharashtra"), // Bank of Maharashtra
  from: GetTranslationData("UIClient", "from"), // from
  giftstaccAccess: GetTranslationData("UIClient", "giftstacc_access_message"), // Giftstacc! Access here
  tnc: GetTranslationData("UIClient", "tnc"), // T%26C:
  custcap: GetTranslationData("UIClient", "custcap"), // CustCap
  sec: GetTranslationData("UIClient", "sec"), // Sec
  in: GetTranslationData("UIClient", "in"), // in
  youCannotPurchaseMoreThan: GetTranslationData(
    "UIClient",
    "you_cannot_purchase_more_than"
  ),
  giftGardsInTotal: GetTranslationData("UIClient", "gift_cards_in_total"),
  giftCardsForSupplierQuickSilver: GetTranslationData(
    "UIClient",
    "gift_cards_for_supplier_QuickSilver"
  ),
  orderCancelled: GetTranslationData("UIClient", "order_cancelled"),
  orderDetailsMessage: GetTranslationData("UIClient", "order_details_message"),
  discount_flat: GetTranslationData("UIClient", "discount_flat"),
  max_capping_allowed: GetTranslationData("UIClient", "max_capping_allowed"),
  max_limit_allowed: GetTranslationData("UIClient", "max_limit_allowed"),
  with: GetTranslationData("UIClient", "with"),
  order_failure: GetTranslationData("UIClient", "order_failure"),
  e_gift_card_purchase: GetTranslationData("UIClient", "e_gift_card_purchase"),
  redeem_text: GetTranslationData("UIClient", "redeem_text"),
  order_failed: GetTranslationData("UIClient", "order_failed"),
  gift_card_purchase: GetTranslationData("UIClient", "gift_card_purchase"),
  your_order_text: GetTranslationData("UIClient", "your_order_text"),
  order_proccessing_message: GetTranslationData("UIClient", "order_proccessing_message"),
  hang_tight: GetTranslationData("UIClient", "hang_tight"),
  continue_shopping: GetTranslationData("UIClient", "continue_shopping"),
  plus_gst: GetTranslationData("UIClient", "plus_gst"),
  convenience_fe: GetTranslationData("UIClient", "convenience_fe"),
  terms_condition: GetTranslationData("UIClient", "terms&condition"),
  how_to_use: GetTranslationData("UIClient", "how_to_use"),
  outof: GetTranslationData("UIClient", "out_of"),

  calculate_reward_points_on: GetTranslationData("UIClient", "calculate_reward_points_on"),
  american_express: GetTranslationData("UIClient", "american_express"),
  you_will_earn_lower: GetTranslationData("UIClient", "you_will_earn_lower"),
  reward_points: GetTranslationData("UIClient", "reward_points"),
  you_will_earn_label: GetTranslationData("UIClient", "you_will_earn_label"),
  purchase_limit_alert: GetTranslationData("UIClient", "purchase_limit_alert"),
  next_month: GetTranslationData("UIClient", "next_month"),
  next_week: GetTranslationData("UIClient", "next_week"),
  next_day: GetTranslationData("UIClient", "next_day"),
  processing_payment_heade_msg: GetTranslationData("UIClient", "processing_payment_heade_msg"),
  processing_payment_description_msg_1: GetTranslationData("UIClient", "processing_payment_description_msg_1"),
  processing_payment_description_msg_2: GetTranslationData("UIClient", "processing_payment_description_msg_2"),
  view_orders: GetTranslationData("UIClient", "view_orders"),
  payment_processing_color_label: GetTranslationData("UIClient", "payment_processing_color_label"),
  widget_popup_title: GetTranslationData("UIClient", "widget_popup_title"),
  widget_earn_txt: GetTranslationData("UIClient", "widget_earn_txt"),
  widget_reward_points_limit_txt: GetTranslationData("UIClient", "widget_reward_points_limit_txt"),
  session_expire_heading: GetTranslationData("UIClient", "session_expire_heading"),
  session_expire_msg: GetTranslationData("UIClient", "session_expire_msg"),
  rem_limit_heading: GetTranslationData("UIClient", "rem_limit_heading"),
  searchbybrand: GetTranslationData("UIClient", "searchbybrand"),
  ReachUsAT: GetTranslationData("UIClient", "ReachUsAT"),
  contactus_number: GetTranslationData("UIClient", "contactus_number"),
  contact_available: GetTranslationData("UIClient", "contact_available"),
  This_brand_available_with_the_current_filters: GetTranslationData("UIClient", "This_brand_available_with_the_current_filters"),
  points_credited_successful_transaction: GetTranslationData("UIClient", "points_credited_successful_transaction"),
  keepTyping: GetTranslationData("UIClient", "keepTyping"),
  CompleteFirstOrder: GetTranslationData("UIClient", "complete_first_order"),
  UnableToResendTheCode: GetTranslationData("UIClient", "unable_to_resend_the_code"),
  VoucherSuccessMessage: GetTranslationData("UIClient", "voucher_success_message"),
  email_required: GetTranslationData("UIClient", "email_required"),
  firstName_required: GetTranslationData("UIClient", "firstName_required"),
  lastName_required: GetTranslationData("UIClient", "lastName_required"),
  mobile_number_required: GetTranslationData("UIClient", "mobile_number_required"),
  email_validation_message: GetTranslationData("UIClient", "email_validation_message"),
  ReLoginAtCheckoutPage: GetTranslationData("UIClient", "re_login_msg_at_checkout_page"),

  redirecting_text: GetTranslationData("UIClient", "redirecting_text"),
  confirm_process: GetTranslationData("UIClient", "confirm_process"),
  confirm_text: GetTranslationData("UIClient", "confirm_text"),
});
export default getTranslationData;
